/* Reia — Editorial Article Template
 * Self-contained: scroll-reveal, reading-progress bar, and auto-built table of contents.
 * No dependency on theme.js's animation controllers (those are wired per-selector there).
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-reia-article]');
  if (!root) return;

  /* Scroll reveal */
  if (document.documentElement.classList.contains('do-anim') && 'IntersectionObserver' in window) {
    var revealTargets = root.querySelectorAll('.reia-article-hero > *, .reia-article__main > *');
    var revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -10% 0px' }
    );
    revealTargets.forEach(function (el) {
      revealObserver.observe(el);
    });
  } else {
    root.querySelectorAll('.reia-article-hero > *, .reia-article__main > *').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  /* Reading progress bar */
  var progressBar = root.querySelector('[data-reia-article-progress]');
  var mainEl = root.querySelector('.reia-article__main');
  if (progressBar && mainEl) {
    var ticking = false;
    var updateProgress = function () {
      var rect = mainEl.getBoundingClientRect();
      var start = rect.top + window.scrollY;
      var total = mainEl.offsetHeight - window.innerHeight;
      var scrolled = window.scrollY - start;
      var pct = total > 0 ? Math.min(100, Math.max(0, (scrolled / total) * 100)) : 0;
      progressBar.style.width = pct + '%';
      ticking = false;
    };
    updateProgress();
    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(updateProgress);
          ticking = true;
        }
      },
      { passive: true }
    );
    window.addEventListener('resize', updateProgress);
  }

  /* Hero excerpt: capped to a few lines via CSS line-clamp. Only reveal the
   * Read more toggle when the text actually overflows, so short excerpts
   * render normally with no dangling control. */
  root.querySelectorAll('[data-reia-hero-excerpt]').forEach(function (wrap) {
    var text = wrap.querySelector('.reia-article-hero__excerpt');
    var toggle = wrap.querySelector('[data-reia-hero-excerpt-toggle]');
    if (!text || !toggle) return;
    if (text.scrollHeight <= text.clientHeight + 1) return;
    toggle.hidden = false;
    toggle.addEventListener('click', function () {
      var expanded = wrap.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      toggle.textContent = expanded ? 'Read less' : 'Read more';
    });
  });

  /* Wide tables: wrap any <table> not already inside the theme's own
   * .rte__table-wrapper (article content pasted as raw HTML skips Shopify's
   * native table-wrapping) so wide/many-column tables scroll horizontally
   * on mobile instead of squeezing their columns or breaking page layout. */
  var rteForTables = root.querySelector('[data-reia-article-rte]');
  if (rteForTables) {
    rteForTables.querySelectorAll('table').forEach(function (table) {
      if (table.closest('.rte__table-wrapper')) return;
      var wrapper = document.createElement('div');
      wrapper.className = 'rte__table-wrapper';
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });
  }

  /* Table of contents: built from real headings inside the article body */
  var rte = root.querySelector('[data-reia-article-rte]');
  var tocLists = root.querySelectorAll('[data-reia-article-toc-list]');
  if (rte && tocLists.length) {
    var headings = rte.querySelectorAll('h2, h3');
    if (headings.length) {
      var usedSlugs = {};
      var slugify = function (text) {
        var base = text
          .toLowerCase()
          .trim()
          .replace(/[^a-z0-9\s-]/g, '')
          .replace(/\s+/g, '-');
        var slug = base || 'section';
        var i = 2;
        while (usedSlugs[slug]) {
          slug = base + '-' + i;
          i += 1;
        }
        usedSlugs[slug] = true;
        return slug;
      };

      var fragment = document.createDocumentFragment();
      var linksByHeadingId = [];
      headings.forEach(function (heading) {
        if (!heading.id) {
          heading.id = slugify(heading.textContent);
        }
        var level = heading.tagName === 'H3' ? '3' : '2';
        var li = document.createElement('li');
        li.setAttribute('data-level', level);
        var a = document.createElement('a');
        a.href = '#' + heading.id;
        a.textContent = heading.textContent;
        li.appendChild(a);
        fragment.appendChild(li);
        linksByHeadingId.push({ id: heading.id, heading: heading });
      });

      /* The browser's native #hash scroll-on-load runs before these IDs
       * exist (assigned above), so a deep link to a section silently fails
       * to scroll. Replay it now that the target heading has its id. */
      if (location.hash) {
        var hashTarget = document.getElementById(location.hash.slice(1));
        if (hashTarget) {
          hashTarget.scrollIntoView({ block: 'start' });
        }
      }

      tocLists.forEach(function (list) {
        list.appendChild(fragment.cloneNode(true));
        var wrapper = list.closest('[data-reia-article-toc]');
        if (wrapper) wrapper.hidden = false;
        var mobileWrapper = list.closest('.reia-article__toc-mobile');
        if (mobileWrapper) mobileWrapper.hidden = false;
      });

      if ('IntersectionObserver' in window) {
        var allTocLinks = root.querySelectorAll('[data-reia-article-toc-list] a');
        var setActive = function (id) {
          allTocLinks.forEach(function (link) {
            link.classList.toggle('is-active', link.getAttribute('href') === '#' + id);
          });
        };
        var headingObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                setActive(entry.target.id);
              }
            });
          },
          { rootMargin: '-20% 0px -70% 0px' }
        );
        linksByHeadingId.forEach(function (item) {
          headingObserver.observe(item.heading);
        });
      }
    }
  }

  /* Smooth scroll for TOC / anchor links within this section */
  root.addEventListener('click', function (event) {
    var link = event.target.closest('a[href^="#"]');
    if (!link || !root.contains(link)) return;
    var targetId = link.getAttribute('href').slice(1);
    var target = document.getElementById(targetId);
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    history.replaceState(null, '', '#' + targetId);
  });
})();

/* Share modal — same behavior as the product page's share modal, scoped to
 * this article's own data-reia-share-* attributes so the two never collide. */
(function () {
  'use strict';

  var overlay = document.querySelector('[data-reia-share-overlay]');
  var modal = document.querySelector('[data-reia-share-modal]');
  var closeBtn = document.querySelector('[data-reia-share-close]');
  var copyBtn = document.querySelector('[data-reia-share-copy]');
  var toast = document.querySelector('[data-reia-share-toast]');
  var openBtns = document.querySelectorAll('[data-reia-share-open]');
  if (!overlay || !modal || !openBtns.length) return;

  var focusableEls;
  var previouslyFocused;

  var getFocusable = function () {
    return modal.querySelectorAll('button, a[href], [tabindex]:not([tabindex="-1"])');
  };

  var handleKeydown = function (event) {
    if (event.key === 'Escape') {
      closeModal();
      return;
    }
    if (event.key === 'Tab') {
      focusableEls = getFocusable();
      if (!focusableEls.length) return;
      var first = focusableEls[0];
      var last = focusableEls[focusableEls.length - 1];
      if (event.shiftKey) {
        if (document.activeElement === first) {
          event.preventDefault();
          last.focus();
        }
      } else if (document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  };

  function openModal() {
    previouslyFocused = document.activeElement;
    overlay.hidden = false;
    requestAnimationFrame(function () {
      overlay.classList.add('is-visible');
    });
    focusableEls = getFocusable();
    if (focusableEls.length) focusableEls[0].focus();
    document.addEventListener('keydown', handleKeydown);
  }

  function closeModal() {
    overlay.classList.remove('is-visible');
    overlay.addEventListener('transitionend', function handler() {
      overlay.hidden = true;
      overlay.removeEventListener('transitionend', handler);
    });
    document.removeEventListener('keydown', handleKeydown);
    if (previouslyFocused) previouslyFocused.focus();
  }

  var showToast = function () {
    if (!toast) return;
    toast.hidden = false;
    requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });
    setTimeout(function () {
      toast.classList.remove('is-visible');
      toast.addEventListener('transitionend', function handler() {
        toast.hidden = true;
        toast.removeEventListener('transitionend', handler);
      });
    }, 2000);
  };

  openBtns.forEach(function (btn) {
    btn.addEventListener('click', openModal);
  });

  if (closeBtn) closeBtn.addEventListener('click', closeModal);

  overlay.addEventListener('click', function (event) {
    if (event.target === overlay) closeModal();
  });

  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var url = this.getAttribute('data-url');
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () {
          showToast();
          closeModal();
        });
      } else {
        var textarea = document.createElement('textarea');
        textarea.value = url;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        showToast();
        closeModal();
      }
    });
  }
})();
